import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, ShieldCheck } from "lucide-react";

import { adminLogin } from "@/lib/api";
import { useToast } from "@/hooks/use-toast";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      const data = await adminLogin(email, password);
      localStorage.setItem("ce_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      toast({
        title: "Login mislukt",
        description: err?.response?.data?.detail || "Ongeldige gegevens",
        variant: "destructive",
      });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <span className="inline-flex h-10 w-10 rounded-xl bg-blue-500 items-center justify-center text-white">
            <ShieldCheck className="h-6 w-6" />
          </span>
          <span className="font-display text-2xl font-bold tracking-tight text-white">
            Check<span className="text-blue-300">Expert</span> <span className="text-slate-400 font-normal text-sm">Admin</span>
          </span>
        </div>
        <form onSubmit={submit} className="rounded-2xl bg-white p-8 space-y-5 shadow-2xl">
          <div>
            <Label htmlFor="email">E-mail</Label>
            <Input
              id="email" type="email" required
              value={email} onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              data-testid="admin-email"
            />
          </div>
          <div>
            <Label htmlFor="password">Wachtwoord</Label>
            <Input
              id="password" type="password" required
              value={password} onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              data-testid="admin-password"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="w-full px-5 py-3 rounded-full bg-[#002FA7] hover:bg-[#0033B5] text-white font-semibold disabled:opacity-50 inline-flex items-center justify-center gap-2"
            data-testid="admin-submit"
          >
            <Lock className="h-4 w-4" /> {submitting ? "Inloggen…" : "Inloggen"}
          </button>
          <p className="text-xs text-ink-subtle text-center">
            Bij 6 mislukte pogingen wordt het account 15 minuten vergrendeld.
          </p>
          <Link to="/admin/reset-password" className="block text-center text-xs text-[#002FA7] font-semibold hover:underline">
            Wachtwoord vergeten?
          </Link>
        </form>
      </div>
    </div>
  );
}
